import * as yup from 'yup';

import { TPersonTitleDE } from '../../form/form';

// Copied from PersonalDetailsDE.schema.ts — keep in sync if the desktop rule changes.
export const nameSchema = yup.object().shape({
  title: yup.string<TPersonTitleDE>().required('benötigt'),
  firstName: yup.string().trim().required('benötigt'),
  lastName: yup.string().trim().required('benötigt'),
});
